import { createBrowserRouter, Outlet, ScrollRestoration, useMatch } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import LandingPage from './components/LandingPage';
import ProductsPage from './components/ProductsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import DataDeletion from './components/DataDeletion';
import TermsOfService from './components/TermsOfService';
import ChatWindow from './components/ChatWindow';
import NotFoundPage from './components/NotFoundPage';
import ChatWidget from './components/landing/ChatWidget';

// Root layout: scroll handling for every route (top of page on navigation,
// position restored on back/forward, #hash targets scrolled into view) and
// the chat launcher on every page except the embedded chat itself.
function RootLayout() {
  const isChatRoute = useMatch('/chat/:id') !== null;
  return (
    <>
      <Outlet />
      {!isChatRoute && <ChatWidget />}
      <ScrollRestoration />
    </>
  );
}

// Router configuration
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage variant="error" />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'products',
        element: <ProductsPage />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'data-deletion',
        element: <DataDeletion />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfService />,
      },
      {
        path: 'chat/:id',
        element: <ChatWindow />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
